/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_a654863c"]'><div :class='["radio-modal-slots-demo"]'><cube-checkbox-group-modal ref="__mpx_ref_checkboxModal__" :show-close-icon="(true)" :options="(options)" :values="(value)"><div slot="title" :class='["modal-title"]'>标题slot</div><div slot="subtitle" :class='["modal-subtitle"]'>副标题slot</div></cube-checkbox-group-modal><cube-button @_click="onTap">checkbox-modal-slots</cube-button></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_a654863c"}'>
.modal-title
  font-size 20px
  font-weight bold
  margin-bottom 10px
.modal-subtitle
  margin-bottom 10px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_a654863c"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_a654863c"}
  /** script content **/
  require("./checkbox-modal-slots.mpx.js?isComponent&outputPath=components%2Fcheckbox-modal-slotsa654863c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./checkbox-modal-slots.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fcheckbox-modal-slotsa654863c%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_a654863c"],
    ctorType: "component",
    outputPath: "components/checkbox-modal-slotsa654863c/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-checkbox-group-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/checkbox-modal/index.mpx?isComponent&outputPath=components%2Findex37cd7d2c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>